import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/** Wraps case-insensitive matches of `query` in `text` with a highlight mark. */
export function highlight(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q) return text;
  const idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <Box
        component="mark"
        sx={{ bgcolor: 'warning.main', color: 'warning.contrastText', px: 0.25, borderRadius: 0.5 }}
      >
        {text.slice(idx, idx + q.length)}
      </Box>
      {text.slice(idx + q.length)}
    </>
  );
}
